import React, { Component } from 'react';
import { connect } from 'react-redux'


import AppStack from './AppStack'
import PortfolioCard from './PortfolioCard';

class Portfolio extends Component {

	constructor(props){

       super(props);

  }

	renderCard(item){
		return (
			<PortfolioCard {...item} />
		);
	}

	render(){

		const items = this.props.portfolio.items.map((item) =>  <PortfolioCard {...item} key={item.slug} /> );

		return (

			<AppStack className="portfolio">

				<section className="wysiwyg">


					<div className="container">

						<div className="page-title-container"><div className="page-title"><h1>Portfolio</h1></div></div>

						<div className="body">
							{items}
						</div>

					</div>

				</section>

			</AppStack>
		);

	}

}



const mapStateToProps = (state) => {
	return { portfolio: state.Portfolio };
}
const mapDispatchToProps = (dispatch) => {
	return {
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Portfolio)



// WEBPACK FOOTER //
// ./src/Components/Portfolio.js